const unescapeString = (str: string) =>
  new DOMParser().parseFromString(`<!doctype html><body>${str}`, 'text/html').body.textContent;

export default unescapeString;
